
import { Component, Prop, Vue, Provide, Watch } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import changeAirport from '../assets/js/airport/changeAirport';

@Component({
    filters: {
        Date(data: any) {
            return moment(data).format('YYYY-MM-DD HH:mm');
        },
    },
})
export default class WorkflowView extends Vue {
    @Prop() private Activitylist: any; // 获取到的工作流流程
    @Prop() private WorkflowStatus: any; // 获取到的工作流状态
}
